import { BillingStatus } from './../../models/payments.model';
import {
  Timesheet,
  TimesheetWithEntry
} from '../../models/timesheets/timesheet.model';

import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export const mockTimesheetsWithEntry: TimesheetWithEntry[] = [
  {
    createdAt: '2025-02-05T10:20:00Z',
    updatedAt: '2025-02-05T10:25:00Z',
    id: 'ts-001',
    timesheetId: 'tsh-001',
    contractorId: 'ctr-101',
    contractorName: 'Alice Thompson',
    facilityId: 'fac-88',
    facilityName: 'Evergreen Medical Center',
    weekStartDate: '2025-02-03',
    weekEndDate: '2025-02-09',
    timesheetStatus: BillingStatus.PENDING,
    timesheetStatusDisplay: BillingStatus.PENDING,
    submittedAt: '2025-02-05T12:00:00Z',
    approvedAt: '',
    approvedByName: '',
    entryId: 'ent-001',
    shiftId: 'sh-001',
    shiftDate: '2025-02-03',
    startTime: '2025-02-03T08:00:00Z',
    endTime: '2025-02-03T16:00:00Z',
    hoursWorked: 8,
    hourlyRate: 42,
    lineTotal: 336,
    scopeOfPractice: ScopeOfPracticeEnum.Cna,
    supervisorName: 'Dr. Michael Carter',
    breakDurationMinutes: 30,
    contractorNotes: 'No issues during the shift.',
    timesheetNumber: 4,
    timesheetNumberDisplay: 'TS-00004'
  },
  {
    createdAt: '2025-02-02T15:10:00Z',
    updatedAt: '2025-02-04T09:18:00Z',
    id: 'ts-002',
    timesheetId: 'tsh-002',
    contractorId: 'ctr-102',
    contractorName: 'David Rodriguez',
    facilityId: 'fac-72',
    facilityName: 'Northside General Hospital',
    weekStartDate: '2025-01-27',
    weekEndDate: '2025-02-02',
    timesheetStatus: BillingStatus.APPROVED,
    timesheetStatusDisplay: BillingStatus.APPROVED,
    submittedAt: '2025-02-01T17:40:00Z',
    approvedAt: '2025-02-02T08:30:00Z',
    approvedByName: 'Sarah Miller',
    entryId: 'ent-002',
    shiftId: 'sh-177',
    shiftDate: '2025-01-30',
    startTime: '2025-01-30T19:00:00Z',
    endTime: '2025-01-31T03:00:00Z',
    hoursWorked: 8,
    hourlyRate: 45,
    lineTotal: 360,
    scopeOfPractice: ScopeOfPracticeEnum.Rn,
    supervisorName: 'Nurse Supervisor Henry Clark',
    breakDurationMinutes: 20,
    contractorNotes: '',
    timesheetNumber: 3,
    timesheetNumberDisplay: 'TS-00003'
  },
  {
    createdAt: '2025-02-08T11:00:00Z',
    updatedAt: '2025-02-08T11:30:00Z',
    id: 'ts-003',
    timesheetId: 'tsh-003',
    contractorId: 'ctr-103',
    contractorName: 'Maria Lopez',
    facilityId: 'fac-90',
    facilityName: 'Sunrise Acute Care',
    weekStartDate: '2025-02-03',
    weekEndDate: '2025-02-09',
    timesheetStatus: BillingStatus.REJECTED,
    timesheetStatusDisplay: BillingStatus.REJECTED,
    submittedAt: '2025-02-07T22:00:00Z',
    approvedAt: '',
    approvedByName: '',
    entryId: 'ent-003',
    shiftId: 'sh-301',
    shiftDate: '2025-02-05',
    startTime: '2025-02-05T07:00:00Z',
    endTime: '2025-02-05T15:00:00Z',
    hoursWorked: 8,
    hourlyRate: 40,
    lineTotal: 320,
    scopeOfPractice: ScopeOfPracticeEnum.Hha,
    supervisorName: 'Supervisor Karen Evans',
    breakDurationMinutes: 15,
    contractorNotes: 'Dispute regarding recorded start time.',
    timesheetNumber: 1,
    timesheetNumberDisplay: 'TS-00001'
  },
  {
    createdAt: '2025-02-09T08:40:00Z',
    updatedAt: '2025-02-09T09:00:00Z',
    id: 'ts-004',
    timesheetId: 'tsh-004',
    contractorId: 'ctr-104',
    contractorName: 'James Walker',
    facilityId: 'fac-55',
    facilityName: 'Valley Health Center',
    weekStartDate: '2025-02-03',
    weekEndDate: '2025-02-09',
    timesheetStatus: BillingStatus.CANCELLED,
    timesheetStatusDisplay: BillingStatus.CANCELLED,
    submittedAt: '2025-02-06T14:00:00Z',
    approvedAt: '2025-02-07T10:15:00Z',
    approvedByName: 'Emily Ross',
    entryId: 'ent-004',
    shiftId: 'sh-410',
    shiftDate: '2025-02-04',
    startTime: '2025-02-04T14:00:00Z',
    endTime: '2025-02-04T22:30:00Z',
    hoursWorked: 8.5,
    hourlyRate: 50,
    lineTotal: 425,
    scopeOfPractice: ScopeOfPracticeEnum.Pt,
    supervisorName: 'Dr. Steven Brooks',
    breakDurationMinutes: 25,
    contractorNotes: '',
    timesheetNumber: 2,
    timesheetNumberDisplay: 'TS-00002'
  }
];

export const mockTimesheets: Timesheet[] = [
  {
    id: '3f9a8c5e-1b6e-4b0c-9a1e-1f4e2a7c91a1',
    contractorId: 'a12d3b4c-1111-4aab-9c01-ff1234567890',
    contractorName: 'Alex Mamani',
    facilityId: 'fac-001',
    facilityName: 'Lima General Hospital',
    weekStartDate: '2025-11-03',
    weekEndDate: '2025-11-09',
    totalHours: 40,
    totalAmount: 2000,
    netTotalAmount: 1994.75,
    transactionFeeAmount: 5.25,
    status: BillingStatus.APPROVED,
    statusDisplay: 'Approved',
    createdAt: '2025-11-09T18:00:00Z',
    updatedAt: '2025-11-10T09:00:00Z',
    submittedAt: '2025-11-09T18:05:00Z',
    approvedAt: '2025-11-10T09:00:00Z',
    approvedByName: 'Maria Gonzalez',
    rejectionReason: '',
    entries: [
      {
        id: 'e1b2c3d4-aaaa-4bbb-8ccc-111111111111',
        shiftId: 'shift-001',
        shiftDate: '2025-11-03',
        hoursWorked: 8,
        hourlyRate: 50,
        lineTotal: 400,
        facilityName: 'Lima General Hospital',
        scopeOfPractice: 'RN',
        startTime: '08:00',
        endTime: '16:00'
      },
      {
        id: 'e1b2c3d4-aaaa-4bbb-8ccc-222222222222',
        shiftId: 'shift-002',
        shiftDate: '2025-11-04',
        hoursWorked: 8,
        hourlyRate: 50,
        lineTotal: 400,
        facilityName: 'Lima General Hospital',
        scopeOfPractice: 'RN',
        startTime: '08:00',
        endTime: '16:00'
      }
    ]
  },

  {
    id: '7b2f6d9c-8e24-4b57-9c3d-55f9a9c21c02',
    contractorId: 'a12d3b4c-1111-4aab-9c01-ff1234567890',
    contractorName: 'Alex Mamani',
    facilityId: 'fac-001',
    facilityName: 'Lima General Hospital',
    weekStartDate: '2025-11-10',
    weekEndDate: '2025-11-16',
    totalHours: 36,
    totalAmount: 1800,
    netTotalAmount: 1795.25,
    transactionFeeAmount: 4.75,
    status: BillingStatus.PAID,
    statusDisplay: 'Paid',
    createdAt: '2025-11-16T18:00:00Z',
    updatedAt: '2025-11-18T10:00:00Z',
    submittedAt: '2025-11-16T18:10:00Z',
    approvedAt: '2025-11-17T09:00:00Z',
    approvedByName: 'Carlos Ruiz',
    rejectionReason: '',
    entries: [
      {
        id: 'f9a8b7c6-dddd-4eee-9fff-333333333333',
        shiftId: 'shift-010',
        shiftDate: '2025-11-11',
        hoursWorked: 12,
        hourlyRate: 50,
        lineTotal: 600,
        facilityName: 'Lima General Hospital',
        scopeOfPractice: 'RN',
        startTime: '07:00',
        endTime: '19:00'
      }
    ]
  },

  {
    id: 'c4e2a9b1-5c77-42c9-9d33-88a9a1f0a903',
    contractorId: 'a12d3b4c-1111-4aab-9c01-ff1234567890',
    contractorName: 'Alex Mamani',
    facilityId: 'fac-002',
    facilityName: 'Miraflores Medical Center',
    weekStartDate: '2025-11-17',
    weekEndDate: '2025-11-23',
    totalHours: 42,
    totalAmount: 2100,
    netTotalAmount: 2094.5,
    transactionFeeAmount: 5.5,
    status: BillingStatus.PENDING,
    statusDisplay: 'Pending',
    createdAt: '2025-11-23T18:00:00Z',
    updatedAt: '2025-11-23T18:00:00Z',
    submittedAt: '2025-11-23T18:05:00Z',
    approvedAt: '',
    approvedByName: '',
    rejectionReason: '',
    entries: [
      {
        id: 'abcd1234-1111-4bbb-8ccc-444444444444',
        shiftId: 'shift-020',
        shiftDate: '2025-11-18',
        hoursWorked: 10,
        hourlyRate: 50,
        lineTotal: 500,
        facilityName: 'Miraflores Medical Center',
        scopeOfPractice: 'RN',
        startTime: '09:00',
        endTime: '19:00'
      }
    ]
  },

  {
    id: '9d3a7c2e-2c44-4a2f-8b18-0c8c9d5e7d04',
    contractorId: 'a12d3b4c-1111-4aab-9c01-ff1234567890',
    contractorName: 'Alex Mamani',
    facilityId: 'fac-002',
    facilityName: 'Miraflores Medical Center',
    weekStartDate: '2025-11-24',
    weekEndDate: '2025-11-30',
    totalHours: 38,
    totalAmount: 1900,
    netTotalAmount: 1895.25,
    transactionFeeAmount: 4.75,
    status: BillingStatus.REJECTED,
    statusDisplay: 'Rejected',
    createdAt: '2025-11-30T18:00:00Z',
    updatedAt: '2025-12-01T09:00:00Z',
    submittedAt: '2025-11-30T18:10:00Z',
    approvedAt: '',
    approvedByName: '',
    rejectionReason: 'Missing supervisor signature',
    entries: [
      {
        id: 'ffffeeee-dddd-4ccc-bbbb-555555555555',
        shiftId: 'shift-030',
        shiftDate: '2025-11-25',
        hoursWorked: 8,
        hourlyRate: 50,
        lineTotal: 400,
        facilityName: 'Miraflores Medical Center',
        scopeOfPractice: 'RN',
        startTime: '08:00',
        endTime: '16:00'
      }
    ]
  }
];
